module.exports = __webpack_public_path__ + "static/media/Portrait-10220.0eb28c3e.jpg";